<template>
  <div class="w-full grid md:grid-cols-5 grid-cols-2 md:gap-4 gap-2 box-border p-[10px]">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="w-full flex items-center justify-center flex-col"
      @click="handelVideo(item)"
    >
      <img
        class="w-full max-h-[140px] h-full rounded-[5px] object-cover"
        v-lazy="item.vod_pic"
        alt=""
      />
      <div class="o-h-e-s text-[14px] text-[#333] min-h-[38px]">
        {{ item.vod_name }}
      </div>
      <div class="text-[12px] text-[#999] w-full flex items-center justify-between">
        <span>{{ item.vod_time }}</span>
        <!-- <span>64011次播放</span> -->
        <span>{{ item.vod_duration }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
// const { ref } = window.Vue
import CryptoJS from 'crypto-js'
import { useRouter } from 'vue-router'
// const { useRouter } = window.VueRouter
const router = useRouter()
// 密钥（必须保密，可以存环境变量）
const SECRET_KEY = 'your-secret-key'
function encryptData(data) {
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString()
  return ciphertext
}
const props = defineProps({
  list: {
    type: Array,
    default: () => []
  },
  isType: {
    type: Boolean,
    default: false
  },
  loding: {
    type: Boolean,
    default: false
  }
})
const emits = defineEmits(['onVideo'])
const handelVideo = (item) => {
  localStorage.setItem('video', JSON.stringify(encryptData(item)))
  if (!props.isType) {
    router.push({
      path: '/video',
      query: {
        id: item.type_id
      }
    })
  } else {
    emits('onVideo', item)
  }
}
</script>

<style></style>
